import { render, staticRenderFns } from "./ItemE_Ref.vue?vue&type=template&id=452736ea"
import script from "./ItemE_Ref.vue?vue&type=script&lang=js"
export * from "./ItemE_Ref.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports